import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=6318479b&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318479b",
  null
  
)

export default component.exports